// Opções de status e prioridade compartilhadas
export const statusOptions = [
  { value: "aberto", label: "Aberto", color: "primary", backgroundColor: "#2196F3" },
  { value: "em_andamento", label: "Em Andamento", color: "secondary", backgroundColor: "#FF9800" },
  { value: "fechado", label: "Fechado", color: "default", backgroundColor: "#9E9E9E" },
];

export const priorityOptions = [
  { value: 4, label: "Baixa", color: "default", backgroundColor: "#9E9E9E" },
  { value: 3, label: "Média", color: "secondary", backgroundColor: "#FF9800" },
  { value: 2, label: "Alta", color: "primary", backgroundColor: "#F44336" },
  { value: 1, label: "Urgente", color: "error", backgroundColor: "#D32F2F" },
];

// Funções utilitárias compartilhadas
export const getStatusColor = (status) => {
  const statusOption = statusOptions.find(opt => opt.value === status);
  return statusOption?.backgroundColor || "#7A7373";
};

export const getPriorityColor = (priority) => {
  const priorityOption = priorityOptions.find(opt => opt.value === priority);
  return priorityOption?.backgroundColor || "#7A7373";
};

export const getPriorityFlagColor = (priority) => {
  switch (priority) {
    case 1: // Urgente
      return "#D32F2F"; // Vermelho escuro
    case 2: // Alta
      return "#F44336"; // Vermelho
    case 3: // Média
      return "#FF9800"; // Laranja
    case 4: // Baixa
      return "#9E9E9E"; // Cinza
    default:
      return "#9E9E9E";
  }
};

export const formatDate = (dateString) => {
  if (!dateString) {
    return "Data não disponível";
  }
  
  if (typeof dateString === 'string' && !isNaN(dateString)) {
    const timestamp = parseInt(dateString);
    return new Date(timestamp).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  
  try {
    return new Date(dateString).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (error) {
    return "Data inválida";
  }
}; 